import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=49c6b187&scoped=true&"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js&"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountForm.vue?vue&type=style&index=0&id=49c6b187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6b187",
  null
  
)

export default component.exports